export default "__VITE_ASSET__ew$h9SPy__$_?url__"